export default __webpack_public_path__ + "static/media/ico_square.d9c80698.svg";